module.exports = __webpack_public_path__ + "7b5dc3e69bb72cd790e9b22fe37221fe.png";